import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import { SEMESTER_ALL } from '../constants/actionTypes'
import * as API from '../constants/api'

export const semesterAll = createAsyncThunk(
  SEMESTER_ALL,
  async (params: PayloadCreatorParams<`${typeof API.SEMESTER_ALL}`, 'get'> | undefined, { rejectWithValue }) => {
    try {
      const response = await api.semesterAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const semesterAllClear = createAction(`${SEMESTER_ALL}/clear`)
